"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopPoliciesDashboardWidget = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const styled_components_1 = __importDefault(require("styled-components"));
const core_2 = require("../../../../core");
const features_1 = require("../../..");
const widgets_1 = require("./..");
const TopPoliciesInteractor_1 = require("./TopPoliciesInteractor");
require("./types");
const helpers_1 = require("./helpers");
const components_2 = require("../../../../components");
const Wrapper = styled_components_1.default(components_1.StackView) `
  height: 100%;
`;
const TopPoliciesDashboardWidget = ({ dataGridLoader, onPolicyClick, }) => {
    const { t } = core_2.useFeatureContext();
    const [isLoading, setIsLoading] = react_1.useState(false);
    const [dataGridModel] = react_1.useState(() => {
        return new features_1.TopPoliciesDataGridModel(dataGridLoader).withSorting({
            key: 'name',
            direction: components_1.SORT_DIRECTION.desc,
        });
    });
    const { interactor } = core_1.useInteractor(() => {
        const durationFilterModel = new widgets_1.DurationFilterModel();
        const typeFilterModel = new widgets_1.TypeFilterModel();
        const presenters = {
            setLoading: setIsLoading,
        };
        return new TopPoliciesInteractor_1.TopPoliciesInteractor(dataGridModel, durationFilterModel, typeFilterModel, presenters);
    });
    return (react_1.default.createElement(components_2.DashboardPlate, { title: t('dashboard|topPolicies|header'), headerAddon: !isLoading ? (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, distribution: components_1.STACK_DISTRIBUTION.between, spaceFill: components_1.SPACE_FILL.all },
            react_1.default.createElement(widgets_1.DurationFilter, { model: interactor.durationFilterModel }),
            react_1.default.createElement(widgets_1.TypeFilter, { model: interactor.typeFilterModel }))) : undefined, content: isLoading ? (react_1.default.createElement(components_2.WidgetSpinner, null)) : (react_1.default.createElement(Wrapper, null,
            react_1.default.createElement(components_1.DataGrid, { model: interactor.dataGridModel, columns: helpers_1.getColumns(t, onPolicyClick), config: { autoLoad: false } }))) }));
};
exports.TopPoliciesDashboardWidget = TopPoliciesDashboardWidget;
//# sourceMappingURL=TopPoliciesDashboardWidget.js.map